import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetTrackingSnippetPageFeatures as GetTrackingSnippetPageFeaturesQuery,
    GetTrackingSnippetPageFeatures_trackingSnippetPageFeatures as TrackingSnippetPageFeatures,
} from 'nutshell-graphql-types';

import GET_TRACKING_SNIPPET_PAGE from '../queries/get-tracking-snippet-page-features.graphql';

export const useGetTrackingSnippetPageFeatures = (): {
    trackingSnippetPageFeatures: TrackingSnippetPageFeatures[];
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch} = useQuery<
        GetTrackingSnippetPageFeaturesQuery,
        Record<any, any>
    >(GET_TRACKING_SNIPPET_PAGE, {
        fetchPolicy: 'cache-and-network',
    });

    const trackingSnippetPageFeatures = data ? data.trackingSnippetPageFeatures : null;

    return {
        trackingSnippetPageFeatures: trackingSnippetPageFeatures || [],
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
